// useCommCode.js
// Axios 기반: 공통코드 조회 후 상태에 저장하는 커스텀 훅

import { useEffect, useCallback } from "react";
import { useApiUtil } from "../utils/apiUtil";

const useCommCode = (setCommCode) => {
  const { gfnCallApi } = useApiUtil();

  const fetchCommCode = useCallback(async () => {
    try {
      const data = await gfnCallApi({
        url: "common/commCode",
        method: "POST",
        showMsg: false,
      });
      if (data?.data) {
        const usedOnly = data.data.filter((item) => item.USED_YN === "1");

        setCommCode({
          ...data,
          data: usedOnly,
        });
      }
    } catch (error) {
      console.error("공통코드 로딩 실패:", error);
    }
  }, [gfnCallApi, setCommCode]);

  useEffect(() => {
    fetchCommCode();
  }, []);
};

export default useCommCode;
